<template>
  <div style="font-size: 4em;"><b-badge variant="secondary">Vue Todo List</b-badge></div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
